import { Tabs } from 'antd';
import { useSearchParams } from 'react-router';
import { PageHeader } from '@/shared/components/page-header';
import { StoreItemsTab } from './store-items';
import { StorePurchasesTab } from './store-purchases';
import { StoreSalesTab } from './store-sales';
import { StoreOutstandingTab } from './store-outstanding';

export function StoreHubPage() {
  const [search, setSearch] = useSearchParams();
  const tab = search.get('tab') ?? 'items';

  return (
    <div style={{ display: 'grid', gap: 20 }}>
      <PageHeader
        eyebrow="Module / Inventory"
        title="School store"
        description="Catalog, stock-in, point-of-sale, and credit follow-up."
      />
      <Tabs
        activeKey={tab}
        onChange={(k) => setSearch({ tab: k })}
        items={[
          { key: 'items', label: 'Items', children: <StoreItemsTab /> },
          { key: 'purchases', label: 'Purchases (stock-in)', children: <StorePurchasesTab /> },
          { key: 'sales', label: 'Sales (POS)', children: <StoreSalesTab /> },
          { key: 'outstanding', label: 'Outstanding credit', children: <StoreOutstandingTab /> },
        ]}
      />
    </div>
  );
}
